<template>
  <p-dialog v-if="visible" v-model="dialog">
    <template v-slot:activator="dialogProps">
      <v-tooltip :disabled="!disabled" left>
        <template v-slot:activator="{ on }">
          <span v-on="on">
            <v-list-item
              v-t="'Security.UserAdministration.PasswordResetSendEmail'"
              :disabled="disabled"
              v-on="dialogProps.on"
            />
          </span>
        </template>
        <span v-text="tooltip" />
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title
        v-t="'Security.UserAdministration.PasswordResetSendEmail'"
        class="headline"
      />
      <v-card-text
        v-t="'Security.UserAdministration.PasswordResetSendEmailDescription'"
        class="pre"
      />
      <v-card-actions>
        <v-spacer></v-spacer>
        <a-btn
          v-t="'Security.UserAdministration.PasswordResetAbort'"
          outlined
          @click="dialog = false"
        />
        <a-btn
          v-t="'Security.UserAdministration.PasswordResetSendEmail'"
          color="primary"
          @click="sendEmail()"
        />
      </v-card-actions>
    </v-card>
  </p-dialog>
</template>

<script>
import Button from "+/components/button/Button";
export default {
  components: {
    "a-btn": Button
  },
  props: {
    user: {
      type: Object,
      default: () => {}
    },
    tooltip: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    dialog: false
  }),
  methods: {
    sendEmail() {
      this.dialog = false;

      this.$rest.security
        .sendPasswordResetMail(this.user.id)
        .then(this.sendingEmailSuccess)
        .catch(this.sendingEmailException);
    },
    sendingEmailSuccess() {
      const successMessage = this.$t(
        "Security.UserAdministration.PasswordResetSendEmailSuccessFeedback"
      );
      this.$feedback(successMessage, {
        type: "success"
      });
    },
    sendingEmailException() {
      const error = this.$t(
        "Security.UserAdministration.PasswordResetSendEmailException"
      );
      this.$feedback(error, { type: "error" });
    }
  }
};
</script>
